import React from 'react';

const TRIP_STATUS = {
  draft:       'bg-gray-100 text-gray-700 border-gray-200',
  scheduled:   'bg-blue-100 text-blue-700 border-blue-200',
  dispatched:  'bg-yellow-100 text-yellow-700 border-yellow-200',
  in_progress: 'bg-green-100 text-green-700 border-green-200',
  paused:      'bg-orange-100 text-orange-700 border-orange-200',
  completed:   'bg-teal-100 text-teal-700 border-teal-200',
  cancelled:   'bg-red-100 text-red-700 border-red-200',
};

const DRIVER_STATUS = {
  active:     'bg-green-100 text-green-700',
  inactive:   'bg-gray-100 text-gray-600',
  on_leave:   'bg-yellow-100 text-yellow-700',
  terminated: 'bg-red-100 text-red-700',
};

const VEHICLE_STATUS = {
  available:      'bg-green-100 text-green-700',
  in_use:         'bg-blue-100 text-blue-700',
  maintenance:    'bg-yellow-100 text-yellow-700',
  out_of_service: 'bg-red-100 text-red-700',
};

const STATUS_DOTS = {
  in_progress: 'bg-green-500 animate-pulse',
  dispatched: 'bg-yellow-500 animate-pulse',
  in_use: 'bg-blue-500 animate-pulse',
};

export function TripStatusBadge({ status, size = 'sm' }) {
  const cls = TRIP_STATUS[status] || 'bg-gray-100 text-gray-600';
  const dot = STATUS_DOTS[status];
  const textSize = size === 'xs' ? 'text-xs' : 'text-xs';
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full font-medium border ${cls} ${textSize}`}>
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />}
      {status.replace(/_/g, ' ')}
    </span>
  );
}

export function DriverStatusBadge({ status }) {
  const cls = DRIVER_STATUS[status] || 'bg-gray-100 text-gray-600';
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${cls}`}>
      {status.replace(/_/g, ' ')}
    </span>
  );
}

export function VehicleStatusBadge({ status }) {
  const cls = VEHICLE_STATUS[status] || 'bg-gray-100 text-gray-600';
  const dot = STATUS_DOTS[status];
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${cls}`}>
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />}
      {status.replace(/_/g, ' ')}
    </span>
  );
}

export function RoleBadge({ role }) {
  const map = {
    administrator: 'bg-purple-100 text-purple-700',
    fleet_manager: 'bg-indigo-100 text-indigo-700',
    dispatcher:    'bg-blue-100 text-blue-700',
    driver:        'bg-gray-100 text-gray-700',
  };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${map[role] || 'bg-gray-100 text-gray-600'}`}>
      {role?.replace(/_/g, ' ')}
    </span>
  );
}
